import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onValue, remove } from "firebase/database";
import PurchaseReturn from "./PurchaseReturn";

function ReturnBillsTable() {
  const [returnBills, setReturnBills] = useState([]);
  const [showReturnBill, setShowReturnBill] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [editingBill, setEditingBill] = useState(null);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserEmail(user.email.replace(/[.#$[\]]/g, "_"));
      } else {
        alert("Please sign in to view return bills.");
        setUserEmail(null);
        setReturnBills([]);
      }
    });
    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    if (!userEmail) return;

    const db = getDatabase();
    const returnBillsRef = ref(db, `users/${userEmail}/purchaseReturns`);

    const unsubscribe = onValue(
      returnBillsRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const billsList = Object.keys(data).map((key) => ({
            id: key,
            formData: data[key].formData || {},
            items: data[key].items || [],
            summary: data[key].summary || {},
            createdAt: data[key].createdAt || null,
            createdBy: data[key].createdBy || null,
            updatedAt: data[key].updatedAt || null,
          }));
          setReturnBills(billsList);
        } else {
          setReturnBills([]);
        }
      },
      (error) => {
        console.error("Error fetching return bills: ", error);
        setReturnBills([]);
      }
    );
    return () => unsubscribe();
  }, [userEmail]);

  const handleEdit = (bill) => {
    console.log("Editing bill:", bill);
    console.log("Bill formData:", bill.formData);
    console.log("Bill items:", bill.items);
    console.log("Bill summary:", bill.summary);
    setEditingBill(bill);
    setShowReturnBill(true);
  };

  const handleDeleteBill = async (billId) => {
    if (!userEmail) {
      alert("Please sign in to delete return bill");
      return;
    }

    if (window.confirm("Are you sure you want to delete this return bill?")) {
      try {
        const db = getDatabase();
        const billRef = ref(db, `users/${userEmail}/purchaseReturns/${billId}`);
        await remove(billRef);
        alert("Return bill deleted successfully!");
      } catch (error) {
        console.error("Error deleting return bill:", error);
        alert("Failed to delete return bill.");
      }
    }
  };

  if (!userEmail) {
    return (
      <div style={{
        maxWidth: "100%",
        margin: "0 auto",
        padding: "2rem",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}>
        <div style={{ textAlign: "center", padding: "4rem", color: "#718096", fontSize: "1.1rem" }}>
          <h2>Please login to access the Return Bills</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: "100%",
      margin: "0 auto",
      padding: "2rem",
      backgroundColor: "#f8fafc",
      minHeight: "100vh",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    }}>
      {showReturnBill ? (
        <PurchaseReturn
          billToEdit={editingBill}
          onClose={() => {
            console.log("Closing PurchaseReturn form");
            setShowReturnBill(false);
            setEditingBill(null);
          }}
        />
      ) : (
        <>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "2rem",
            padding: "1.5rem",
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            fontWeight: "600",
            color: "#374151",
          }}>
            <h1 style={{
              fontSize: "2rem",
              fontWeight: "700",
              color: "#2563eb",
              margin: "0",
            }}>Purchase Return Bills</h1>
            <button
              onClick={() => {
                console.log("Opening form to add new return bill");
                setEditingBill(null);
                setShowReturnBill(true);
              }}
              style={{
                padding: "0.875rem 2rem",
                borderRadius: "8px",
                backgroundColor: "#2563eb",
                color: "white",
                fontWeight: "600",
                cursor: "pointer",
                border: "none",
                fontSize: "0.95rem",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
                transform: "translateY(0)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)";
              }}
            >
              + Add Return Bill
            </button>
          </div>

          <div style={{
            backgroundColor: "white",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
            border: "1px solid #e2e8f0",
            overflowX: "auto",
          }}>
            {returnBills.length > 0 ? (
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.9rem",
                border: "1px solid #d1d5db",
              }}>
                <thead>
                  <tr>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                      width: "60px",
                    }}>MRR NO</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>MRR DATE</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>SUPPLIER</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>INVOICE NO</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>INVOICE DATE</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>NET AMOUNT</th>
                    <th style={{
                      padding: "1rem 0.75rem",
                      textAlign: "center",
                      backgroundColor: "#2563eb",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "1px solid #1e40af",
                    }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {returnBills.map((bill, index) => (
                    <tr
                      key={bill.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f7fafc" : "white",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#2563eb",
                        width: "60px",
                      }}>
                        {bill.formData.returnNo || "N/A"}
                      </td>
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}>
                        {bill.formData.returnDate || "N/A"}
                      </td>
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}>
                        {bill.formData.supplier || "N/A"}
                      </td>
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}>
                        {bill.formData.invoiceNo || "N/A"}
                      </td>
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}>
                        {bill.formData.invoiceDate || "N/A"}
                      </td>
                      <td style={{
                        padding: "1rem 0.75rem",
                        border: "1px solid #d1d5db",
                        color: "#374151",
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}>
                        <strong>
                          ₹{Number(bill.summary.netAmount || 0).toFixed(2)}
                        </strong>
                      </td>
                      <td style={{
                        padding: "0.5rem",
                        border: "1px solid #d1d5db",
                        display: "flex",
                        gap: "0.5rem",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                        <button
                          onClick={() => handleEdit(bill)}
                          style={{
                            padding: "0.5rem",
                            borderRadius: "6px",
                            backgroundColor: "#10b981",
                            color: "white",
                            fontWeight: "500",
                            cursor: "pointer",
                            border: "none",
                            fontSize: "0.8rem",
                            transition: "all 0.2s ease",
                            boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
                            transform: "translateY(0)",
                          }}
                          title="Edit Return Bill"
                          onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-1px)";
                            e.target.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.4)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "0 2px 8px rgba(16, 185, 129, 0.3)";
                          }}
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => handleDeleteBill(bill.id)}
                          style={{
                            padding: "0.5rem",
                            borderRadius: "6px",
                            backgroundColor: "#ef4444",
                            color: "white",
                            fontWeight: "500",
                            cursor: "pointer",
                            border: "none",
                            fontSize: "0.8rem",
                            transition: "all 0.2s ease",
                            boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
                            transform: "translateY(0)",
                          }}
                          title="Delete Return Bill"
                          onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-1px)";
                            e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)";
                          }}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{
                textAlign: "center",
                padding: "4rem 2rem",
                color: "#718096",
                fontSize: "1.1rem",
              }}>
                <div style={{ fontSize: "4rem", marginBottom: "1rem", opacity: "0.5" }}>📄</div>
                <h3 style={{ color: "#4a5568", marginBottom: "0.5rem" }}>No Return Bills Found</h3>
                <p style={{ marginBottom: "1.5rem" }}>Get started by adding your first return bill!</p>
                <button
                  onClick={() => {
                    console.log("Opening form to add first return bill");
                    setEditingBill(null);
                    setShowReturnBill(true);
                  }}
                  style={{
                    padding: "1rem 2rem",
                    borderRadius: "8px",
                    backgroundColor: "#2563eb",
                    color: "white",
                    fontWeight: "600",
                    cursor: "pointer",
                    border: "none",
                    fontSize: "1rem",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
                    transform: "translateY(0)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(37, 99, 235, 0.3)";
                  }}
                >
                  + Add Your First Return Bill
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ReturnBillsTable;